var _circle, _circle2, _rect, _path, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgPlayIcon = function SvgPlayIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.5,
    r: 9,
    fill: "url(#playIcon_svg__paint0_linear_4444_30152)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.5,
    r: 8.5,
    stroke: "white",
    strokeOpacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 28,
    height: 28,
    rx: 14,
    fill: "#AAB1F2",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.9505C12 10.5479 12.4515 10.3104 12.7833 10.5385L19.4007 15.088C19.6897 15.2867 19.6897 15.7133 19.4007 15.912L12.7833 20.4615C12.4515 20.6896 12 20.4521 12 20.0495V10.9505Z",
    fill: "#3D50FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "white",
    strokeOpacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "playIcon_svg__filter0_b_4444_30152",
    x: 11,
    y: 11.5,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4444_30152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_4444_30152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "playIcon_svg__filter1_b_4444_30152",
    x: -7,
    y: -6.5,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4444_30152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_4444_30152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "playIcon_svg__paint0_linear_4444_30152",
    x1: 24,
    y1: 15.5,
    x2: 24,
    y2: 33.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05A1C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D50FC"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPlayIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAzNSAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPCEtLSA8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMF9iXzQ0NDRfMzAxNTIpIj4gLS0+CjxjaXJjbGUgY3g9IjI0IiBjeT0iMjQuNSIgcj0iOSIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzQ0NDRfMzAxNTIpIi8+CjxjaXJjbGUgY3g9IjI0IiBjeT0iMjQuNSIgcj0iOC41IiBzdHJva2U9IndoaXRlIiBzdHJva2Utb3BhY2l0eT0iMC4xIi8+CjwhLS0gPC9nPiAtLT4KPCEtLSA8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMV9iXzQ0NDRfMzAxNTIpIj4gLS0+CjxyZWN0IHg9IjEiIHk9IjEuNSIgd2lkdGg9IjI4IiBoZWlnaHQ9IjI4IiByeD0iMTQiIGZpbGw9IiNBQUIxRjIiIGZpbGwtb3BhY2l0eT0iMC4yIi8+CjxwYXRoIGQ9Ik0xMiAxMC45NTA1QzEyIDEwLjU0NzkgMTIuNDUxNSAxMC4zMTA0IDEyLjc4MzMgMTAuNTM4NUwxOS40MDA3IDE1LjA4OEMxOS42ODk3IDE1LjI4NjcgMTkuNjg5NyAxNS43MTMzIDE5LjQwMDcgMTUuOTEyTDEyLjc4MzMgMjAuNDYxNUMxMi40NTE1IDIwLjY4OTYgMTIgMjAuNDUyMSAxMiAyMC4wNDk1VjEwLjk1MDVaIiBmaWxsPSIjM0Q1MEZDIi8+CjxyZWN0IHg9IjEuNSIgeT0iMiIgd2lkdGg9IjI3IiBoZWlnaHQ9IjI3IiByeD0iMTMuNSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLW9wYWNpdHk9IjAuNCIvPgo8IS0tIDwvZz4gLS0+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2JfNDQ0NF8zMDE1MiIgeD0iMTEiIHk9IjExLjUiIHdpZHRoPSIyNiIgaGVpZ2h0PSIyNiIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVHYXVzc2lhbkJsdXIgaW49IkJhY2tncm91bmRJbWFnZSIgc3RkRGV2aWF0aW9uPSIyIi8+CjxmZUNvbXBvc2l0ZSBpbjI9IlNvdXJjZUFscGhhIiBvcGVyYXRvcj0iaW4iIHJlc3VsdD0iZWZmZWN0MV9iYWNrZ3JvdW5kQmx1cl80NDQ0XzMwMTUyIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iZWZmZWN0MV9iYWNrZ3JvdW5kQmx1cl80NDQ0XzMwMTUyIiByZXN1bHQ9InNoYXBlIi8+CjwvZmlsdGVyPgo8ZmlsdGVyIGlkPSJmaWx0ZXIxX2JfNDQ0NF8zMDE1MiIgeD0iLTciIHk9Ii02LjUiIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVHYXVzc2lhbkJsdXIgaW49IkJhY2tncm91bmRJbWFnZSIgc3RkRGV2aWF0aW9uPSI0Ii8+CjxmZUNvbXBvc2l0ZSBpbjI9IlNvdXJjZUFscGhhIiBvcGVyYXRvcj0iaW4iIHJlc3VsdD0iZWZmZWN0MV9iYWNrZ3JvdW5kQmx1cl80NDQ0XzMwMTUyIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iZWZmZWN0MV9iYWNrZ3JvdW5kQmx1cl80NDQ0XzMwMTUyIiByZXN1bHQ9InNoYXBlIi8+CjwvZmlsdGVyPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNDQ0NF8zMDE1MiIgeDE9IjI0IiB5MT0iMTUuNSIgeDI9IjI0IiB5Mj0iMzMuNSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMDVBMUM5Ii8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzNENTBGQyIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";